import { Center, Spinner, keyframes } from '@chakra-ui/react'

// Fade in after a short delay so fast chunk loads never flash a spinner,
// while slow loads still get clear feedback instead of a blank screen.
const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`

interface RouteFallbackProps {
  /** Minimum height of the loading area. Defaults to a comfortable content height. */
  minH?: string
  /** Spinner size (Chakra size token). */
  size?: 'sm' | 'md' | 'lg' | 'xl'
}

/**
 * Loading indicator for Suspense boundaries (route chunks, lazy panels).
 * Fills its container and centers a branded spinner. Use this instead of
 * `fallback={null}`, which leaves a blank gap while the chunk downloads.
 */
const RouteFallback = ({ minH = '240px', size = 'lg' }: RouteFallbackProps) => (
  <Center
    w="100%"
    h="100%"
    minH={minH}
    animation={`${fadeIn} 200ms ease-out 150ms both`}
  >
    <Spinner
      size={size}
      thickness="3px"
      speed="0.7s"
      color="primary.100"
      emptyColor="solid.50"
      aria-label="Loading"
    />
  </Center>
)

export default RouteFallback
